import { render } from "./GemMechanism14.vue?vue&type=template&id=0763176b&scoped=true"
const script = {}

import "./GemMechanism14.vue?vue&type=style&index=0&id=0763176b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0763176b"]])

export default __exports__